export default __webpack_public_path__ + "static/media/Dash_and_Terminal_LE.e8cd691f.jpg";